import React from "react";
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { Link } from "react-router-dom";

const Otpverify = ({
  handleChangeOTP,
  email,
  handleOtpverify,
  otpValue,
  getVerifyLoading,
  handleResendOTP,
}) => {
  const handleSubmit = () => {
    if (otpValue.length === 6) {
      handleOtpverify();
    } else {
      alert("Please enter a complete OTP.");
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-25 flex justify-center items-center z-50">
      <div className="bg-white p-8 rounded-lg shadow-md w-full max-w-lg mx-3 text-center">
        <h2 className="text-xl font-bold text-[#405189] mb-2">Verify OTP</h2>
        <div className="flex justify-center my-4">
          <MdOutlineMarkEmailRead size={100} className="text-[#F48224]" />
        </div>
        <p className="text-sm text-gray-500">
          Please enter the 6 digit code sent to{" "}
          <span className="font-bold">{email}</span>
        </p>
        <div className="mt-6">
          <div className="mb-4 text-start ">
            <label className="block text-sm font-medium mb-2">OTP</label>
            <input
              type="tel"
              placeholder="Enter OTP"
              value={otpValue.otp}
              onChange={handleChangeOTP}
              maxLength="6"
              pattern="\d*"
              inputMode="numeric"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
              required
            />
          </div>
          <button
            type="button"
            onClick={handleSubmit}
            className="w-full bg-[#F48224] flex justify-center text-white py-2 rounded-lg hover:bg-[#e0731a] transition"
          >
            {getVerifyLoading ? <div className="loader"></div> : "Verify"}
          </button>
        </div>
        <p className="mt-4 text-sm text-gray-600">
          Didn’t receive a code?{" "}
          <span
            onClick={handleResendOTP}
            className="text-blue-500 underline cursor-pointer"
          >
            Resend
          </span>
        </p>
        <p className="mt-2 text-sm text-gray-600">
          Back to Login{" "}
          <Link to="/" className="text-blue-500 underline">
            Click here
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Otpverify;
